import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Square,SquareCheckBig, X, Eye } from "lucide-react";
import { format } from 'date-fns';
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ModalAddEvent from '../components/ModalAddEvent';
import ModalAddBank from '../components/ModalAddBank';
import ModalAddVendor from '../components/ModalAddVendor';
import ModalAddPic from '../components/ModalAddPic';
import MyDropzone from '../components/MyDropzone';
import Swal from 'sweetalert2';
import Select from 'react-select';

export default function Create() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  const storedUser = JSON.parse(localStorage.getItem("user"));
  const email = storedUser?.email;

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const email = storedUser?.email;

    fetch(`${process.env.REACT_APP_BASE_URL}api/users/search?email=${encodeURIComponent(email)}`)
        .then((res) => res.json())
        .then((data) => {
            if (data.status === "success") {
            setUser(data.data);
            console.log("Respon api search email:", data.data);
            } else {
            console.error(data.message);
            }
        })
        .catch((err) => console.error(err));
    }, []);

  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({
    type: '',
    event_id: '',
    event: '',
    pic_id: '',
    vendor_id: '',
    vendor: '',
    bank_id: '',
    bank: '',
    cabang: '',
    atas_nama: '',
    no_rek: '',
    request_date: new Date(),
    notes: '',
    approvals: { one: '', two: '' },
    attachments: [],
    dp1: '',
    dp2: '',
    nilai_dp1: '',
    nilai_dp2: '',
    tgl_dp1: '',
    tgl_dp2: '',
    dp1_tgl: '',
    dp2_tgl: '',
    user_input: email,
  });  
  const [nominals, setNominals] = useState([{ note: '', value: '' }]);

  const [events, setEvents] = useState([]);
  const [pic, setPics] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [bank, setBank] = useState([]);
  const [approvals, setApprovals] = useState([]);
  const [dpOptions, setDpOptions] = useState([]);
  const [filteredDpOptions, setFilteredDpOptions] = useState([]); 
  const [openEventModal, setOpenEventModal] = useState(false);
  const [openBankModal, setOpenBankModal] = useState(false);
  const [openVendorModal, setOpenVendorModal] = useState(false);
  const [openPicModal, setOpenPicModal] = useState(false);
  
  useEffect(() => {
    fetchOptions();
  }, []);

  const fetchOptions = async () => {
    try {
        const [
        eventRes,
        picRes,
        vendorRes,
        bankRes,
        rfRes,
        ] = await Promise.all([
        fetch(`${process.env.REACT_APP_BASE_URL}api/events`).then(res => res.json()),
        fetch(`${process.env.REACT_APP_BASE_URL}api/pic`).then(res => res.json()),
        fetch(`${process.env.REACT_APP_BASE_URL}api/vendors`).then(res => res.json()),
        fetch(`${process.env.REACT_APP_BASE_URL}api/bank`).then(res => res.json()),
        fetch(`${process.env.REACT_APP_BASE_URL}api/rf/filterEvent`).then(res => res.json()),
        ]);

        setEvents(eventRes);
        setPics(picRes);
        setVendors(vendorRes);
        setBank(bankRes);
        setDpOptions(rfRes);
    } catch (error) {
        console.error("Failed to fetch options:", error);
    }
  };

    useEffect(() => {
        const fetchApprovals = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/approval`); // Ganti URL jika perlu
            const data = await res.json();

            // Tangani jika data dibungkus di properti 'data'
            const list = Array.isArray(data) ? data : data.data || [];
            // console.log("Data approvals:", approvals);
            setApprovals(list);
        } catch (err) {
            // console.error("Gagal mengambil data approvals:", err);
        }
        };

        fetchApprovals();
    }, []);


//   const handleAttachmentChange = (e) => {
//     setForm({ ...form, attachments: [...e.target.files] });
//   };

  const handleSubmit = async (e) => {
    
    e.preventDefault();
    const data = new FormData();

    // Daftar field yang wajib diisi
    const requiredFields = ["type", "event_id", "bank_id", "vendor_id"];
    
    const fieldLabels = {
        type: "Tipe Ajuan",
        event_id: "Event",
        bank_id: "Bank",
        vendor_id: "Vendor",
    };
    
   const isEmptyValue = (v) => v === "" || v === null || v === undefined;

    const emptyFields = requiredFields.filter((key) => isEmptyValue(form[key]));

    if (emptyFields.length > 0) {
        // Ganti key jadi label ramah pengguna
        const readableLabels = emptyFields.map((key) => fieldLabels[key] || key);

        await Swal.fire({
        title: "Form Belum Lengkap",
        html: `Tolong isi atau pilih dulu <b>${readableLabels.join(", ")}</b> ya...`,
        icon: "warning",
        confirmButtonText: "Periksa Kembali",
        });
        return; // hentikan submit
    }

    // Konfirmasi sebelum submit
    const result = await Swal.fire({
        title: 'Konfirmasi Submit',
        text: "Yakin ingin submit form ajuan ini?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Ya, submit!',
        cancelButtonText: 'Batal'
    });

    if (!result.isConfirmed) {
        return; // batal submit
    }

    Object.entries(form).forEach(([key, value]) => {
      if (key === 'attachments') {
        value.forEach(att => data.append('attachments[]', att.file));
      } else if (key === 'request_date') {
        data.append(key, value.toISOString().split("T")[0]);
      } else if (typeof value === 'object' && value !== null) {
        Object.entries(value).forEach(([k, v]) => {
          data.append(`${key}[${k}]`, v);
        });
      } else {
        data.append(key, value);
      }
    });

    nominals.forEach((item, index) => {
      data.append(`items[${index}][note]`, item.note);
      data.append(`items[${index}][total]`, item.value);
    });

    try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/rf/submit`, {
        method: "POST",
        body: data,
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Submit failed");
        }
        
        await Swal.fire({
            title: 'Berhasil',
            text: 'Form berhasil dikirim!',
            icon: 'success',
            confirmButtonText: 'OK'
        });
        navigate("/");
        
    } catch (error) {
        console.error("Error submitting form:", error);
        Swal.fire({
            title: 'Error',
            text: error.message,
            icon: 'error',
            confirmButtonText: 'OK'
        });
    }
  };

    // search event
  const [eventSearch, setEventSearch] = useState('');
  const [eventSuggestions, setEventSuggestions] = useState([]);
  // search bank account
  const [bankSearch, setBankSearch] = useState('');
  const [bankSuggestions, setBankSuggestions] = useState([]);
  // search vendor account
  const [vendorSearch, setVendorSearch] = useState('');
  const [vendorSuggestions, setVendorSuggestions] = useState([]);
  // search pic
  const [picSearch, setPicSearch] = useState('');
  const [picSuggestions, setPicSuggestions] = useState([]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
        if (eventSearch.length > 1) {
        axios.get(`${process.env.REACT_APP_BASE_URL}api/events/search?query=${eventSearch}`)
            .then(res => setEventSuggestions(res.data))
            .catch(() => setEventSuggestions([]));
        } else {
        setEventSuggestions([]);
        }
    }, 300); // debounce
    return () => clearTimeout(delayDebounce);
  }, [eventSearch]);

  useEffect(() => {
    const delayDebounce2 = setTimeout(() => {
        if (bankSearch?.length > 1) {
        axios.get(`${process.env.REACT_APP_BASE_URL}api/bank/search?query=${bankSearch}`)
            .then(res => setBankSuggestions(res.data))
            .catch(() => setBankSuggestions([]));
        } else {
        setBankSuggestions([]);
        }
    }, 300); // debounce
    return () => clearTimeout(delayDebounce2);
  }, [bankSearch]);

  useEffect(() => {
    const delayDebounce3 = setTimeout(() => {
        if (vendorSearch?.length > 1) {
        axios.get(`${process.env.REACT_APP_BASE_URL}api/vendors/search?query=${vendorSearch}`)
            .then(res => setVendorSuggestions(res.data))
            .catch(() => setVendorSuggestions([]));
        } else {
        setVendorSuggestions([]);
        }
    }, 300); // debounce
    return () => clearTimeout(delayDebounce3);
  }, [vendorSearch]);

  useEffect(() => {
    const delayDebounce4 = setTimeout(() => {
        if (picSearch?.length > 1) {
        axios.get(`${process.env.REACT_APP_BASE_URL}api/pic/search?query=${picSearch}`)
            .then(res => setPicSuggestions(res.data))
            .catch(() => setPicSuggestions([]));
        } else {
        setPicSuggestions([]);
        }
    }, 300); // debounce
    return () => clearTimeout(delayDebounce4);
  }, [picSearch]);

  const formatNumber = (value) => {
    if (!value) return "";
        return new Intl.NumberFormat("id-ID").format(Number(value));
    };

    // Fungsi untuk membersihkan titik atau non-digit agar jadi angka murni
    const parseNumber = (formattedValue) => {
        return formattedValue.replace(/\D/g, "");
    };

    const handleNominalChange = (index, field, value) => {
        const newNominals = [...nominals];
        if (field === "value") {
        const raw = parseNumber(value);
        newNominals[index][field] = raw;
        } else {
        newNominals[index][field] = value;
        }
        setNominals(newNominals);
    };

    const addNominalRow = () => {
        setNominals([...nominals, { note: "", value: "" }]);
    };

    const getTotal = () => {
        return nominals.reduce((acc, curr) => acc + Number(curr.value || 0), 0);
    };

    
    const [showPreview, setShowPreview] = useState(false);

    // handle change untuk semua input text/textarea/select
    const handleChange = (e) => {
        const { event,  value } = e.target;
        setForm((prev) => ({
        ...prev,
        [event]: value
        }));
    };

    // handle file upload (langsung update form.attachments)
    const handleAttachmentChange = (files) => {
        const previewUrls = files.map((file) => ({
            file,
            preview: URL.createObjectURL(file),
        }));

        setForm((prev) => ({
            ...prev,
            attachments: previewUrls,
        }));
    };


    // cleanup URL blob
    useEffect(() => {
        return () => {
        form.attachments.forEach((att) => URL.revokeObjectURL(att.preview));
        };
    }, [form.attachments]);

    const options = filteredDpOptions.map((dp) => ({
        value: dp.id,
        label: `${dp.total 
            ? dp.note 
            : dp.notenote} - ${new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: 'IDR',
            minimumFractionDigits: 0,
            }).format(dp.total ? dp.total : dp.totalnote)}`,
        total: dp.total ? dp.total : dp.totalnote,
        created_at: dp.created_at,
        input_date: dp.input_date,
    }));
    
  return (
    <div className="max-w-full mx-auto p-2">
        <div className="max-w-full mx-auto mt-2 p-4 bg-white rounded shadow">
            {/* Type */}
            <div className='flex flex-row gap-2 justify-between mb-4'>
                <div className='flex flex-col md:w-1/4'>
                    <select
                    className="w-full border p-2 rounded"
                    value={form.type}
                    onChange={(e) => setForm({ ...form, type: e.target.value })}
                        >
                        <option value="">Pilih Tipe Ajuan</option>
                        <option value="um">Permintaan Uang Muka</option>
                        <option value="reimburse">Reimbursement</option>
                        <option value="dp">DP ke Vendor/Talent</option>
                        <option value="pelunasan">Pelunasan ke Vendor/Talent</option>
                    </select>
                </div>
                <div className='flex flex-col md:w1/4'>
                
                    <Link
                        to="/">
                        <button
                            className="w-full bg-black/100 text-left py-2 px-4 rounded text-white hover:bg-gray-700 flex justify-between items-center"
                            >
                            Kembali ke List Ajuan
                        </button>
                    </Link>
                </div>
            </div>
            <div className='flex flex-row gap-2 mb-4'>
                {/* Event */}
                <div className='flex flex-col md:w-1/2'>
                    <div className="flex-1">
                        <label className="block mb-1">Event</label>
                        <div className='flex flex-row gap-2'>
                            <input
                                type="text"
                                className="w-full border p-2 rounded"
                                value={eventSearch || ''}
                                onChange={(e) => {
                                setEventSearch(e.target.value);
                                setForm({ ...form, event_id: '' }); 
                                }}
                                placeholder="Ketik nama event"
                            />
                            {eventSearch.length > 1 && (
                                <div
                                    className="absolute z-10 bg-white border mt-11 border-gray-300 rounded shadow-md"
                                    style={{
                                        maxHeight: "200px", // tinggi maksimal sebelum muncul scroll
                                        overflowY: "auto",
                                        width: "auto",
                                    }}
                                >
                                <ul>
                                {eventSuggestions.map((ev) => (
                                    <li
                                    key={ev.id}
                                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                    onClick={async () => {
                                    setEventSearch(` ${ev.name}`);
                                    setForm({ ...form, event_id: ev.id, dp1: "", dp2: "", event: ev.name });
                                    setEventSuggestions([]);
                                    // FETCH DP berdasarkan id_event
                                        try {
                                            const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/rf/filterEvent?id_event=${ev.id}`);
                                            const data = await res.json();
                                            setFilteredDpOptions(data);
                                        } catch (err) {
                                            console.error("Gagal fetch DP", err);
                                            setFilteredDpOptions([]);
                                        }
                                    }}
                                    >
                                        {ev.name} - {ev.client}
                                    </li>
                                ))}
                                {(form.event_id === "") && (
                                    <li
                                        className="px-4 py-2 hover:bg-gray-100 "
                                        >Gak ada event "{eventSearch}"
                                    </li>
                                )}
                                </ul>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {/* Bank */}
                <div className='flex flex-col md:w-1/2'>
                    <div className="flex-1">
                        <label className="block mb-1">Akun Bank</label>
                        <div className='flex flex-row gap-2'>
                            <input
                                type="text"
                                className="w-full border p-2 rounded"
                                value={bankSearch || ''}
                                onChange={(e) => {
                                setBankSearch(e.target.value);
                                setForm({ ...form, bank_id: '' }); 
                                }}
                                placeholder="Ketik nama bank, atas nama atau nomor rekening"
                            />
                            {bankSearch?.length > 1 && (
                                <div
                                    className="absolute z-10 bg-white border mt-11 border-gray-300 rounded shadow-md"
                                    style={{
                                        maxHeight: "200px", // tinggi maksimal sebelum muncul scroll
                                        overflowY: "auto",
                                        width: "auto",
                                    }}
                                >
                                <ul>
                                    
                                    {bankSuggestions.map((ba) => (
                                        <li
                                        key={ba.id}
                                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                        onClick={() => {
                                            setBankSearch(`${ba.bank} ${ba.no_rek} a/n ${ba.atas_nama}`);
                                            setForm({ ...form, bank_id: ba.id, bank: ba.bank, no_rek: ba.no_rek, atas_nama: ba.atas_nama,cabang: ba.cabang });
                                            setBankSuggestions([]);
                                        }}
                                        >
                                        {ba.bank} {ba.no_rek} a/n {ba.atas_nama} 
                                        </li>
                                    ))
                                    }
                                    {form.bank_id === "" && (
                                        <li
                                            className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-blue-500"
                                            onClick={() => setOpenBankModal(true)} 
                                            >Tambah Akun Bank...
                                        </li>
                                    )}
                                </ul>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className='flex flex-row gap-2 mb-4'>
                {/* Vendor */}
                <div className='flex flex-col md:w-1/2'>
                    <div className="flex-1">
                        <label className="block mb-1">Vendor</label>
                        <div className='flex flex-row gap-2'>
                            <input
                                type="text"
                                className="w-full border p-2 rounded"
                                value={vendorSearch || ''}
                                onChange={(e) => {
                                setVendorSearch(e.target.value);
                                setForm({ ...form, vendor_id: '' }); 
                                }}
                                placeholder="Ketik nama Vendor"
                            />
                            {vendorSearch?.length > 1 && (
                                <div
                                    className="absolute z-10 bg-white border  mt-11 border-gray-300 rounded shadow-md"
                                    style={{
                                        maxHeight: "200px", // tinggi maksimal sebelum muncul scroll
                                        overflowY: "auto",
                                        width: "auto",
                                    }}
                                >
                                <ul>
                                {vendorSuggestions.map((ve) => (
                                    <li
                                    key={ve.id}
                                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                    onClick={() => {
                                        setVendorSearch(` ${ve.name} - ${ve.pic}`);
                                        setForm({ ...form, vendor_id: ve.id, vendor: ve.name });
                                        setVendorSuggestions([]);
                                    }}
                                    >
                                    Vendor: {ve.name} - PIC: {ve.pic}
                                    </li>
                                ))}
                                    {form.vendor_id === "" && (
                                        <li
                                            className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-blue-500"
                                            onClick={() => setOpenVendorModal(true)} 
                                            >Tambah Vendor...
                                        </li>
                                    )}
                                </ul>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>                

            {/* Date */}
            <div>
                <label className="block">Request Payment Date</label>
                <DatePicker
                selected={form.request_date}
                onChange={(date) => setForm({ ...form, request_date: date })}
                className="border p-2 rounded w-full"
                />
            </div>

            {/* Notes & Nominal */}
            <div className='mb-4'>
                <label className="font-semibold">Item</label>
                {nominals.map((item, i) => (
                    <div key={i} className="flex gap-2 mb-2">
                    <textarea
                        placeholder="Keterangan"
                        className="border p-2 w-1/2 rounded"
                        value={item.note}
                        onChange={(e) => handleNominalChange(i, "note", e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Total"
                        className="border p-2 w-1/3 rounded text-right"
                        value={formatNumber(item.value)}
                        onChange={(e) => handleNominalChange(i, "value", e.target.value)}
                    />
                    </div>
                ))}
                {form.type === "um" && (
                <button
                    type="button"
                    onClick={addNominalRow}
                    className="text-blue-600 text-sm mb-4"
                >
                    + Tambah Baris
                </button>
                )}

                <div className="mt-2">
                    <label className="block font-semibold mb-1">Total Keseluruhan</label>
                    <input
                    type="text"
                    readOnly
                    className="border p-2 rounded w-1/3 text-right bg-gray-100"
                    value={formatNumber(getTotal())}
                    />
                </div>
            </div>

            {/* Approval */}
            <div className="grid grid-cols-2 gap-2">
                <div>
                    <label>Approval 1</label>
                    <select
                    className="w-full border p-2 rounded"
                    value={form.approvals.one}
                    onChange={(e) =>
                        setForm({
                        ...form,
                        approvals: { ...form.approvals, one: e.target.value },
                        })
                    }
                    >
                    <option value="">Pilih</option>
                    {Array.isArray(approvals) &&
                        approvals.map((a) => (
                        <option key={a.id} value={a.name}>
                            {a.name}
                        </option>
                        ))}
                    </select>
                </div>
                <div>
                    <label>Approval 2</label>
                    <select
                    className="w-full border p-2 rounded"
                    value={form.approvals.two}
                    onChange={(e) =>
                        setForm({
                        ...form,
                        approvals: { ...form.approvals, two: e.target.value },
                        })
                    }
                    >
                    <option value="">Pilih</option>
                    {Array.isArray(approvals) &&
                        approvals.map((a) => (
                        <option key={a.id} value={a.name}>
                            {a.name}
                        </option>
                        ))}
                    </select>
                </div>
            </div>

            {/* Upload */}
            <div className='gap-2 mt-4'>
                <label>Bukti Approval dan Dokumen Pendukung lainnya (PO, Faktur Pajak, dll)</label>
            <MyDropzone handleAttachmentChange={handleAttachmentChange} />
            </div>

            {/* DP1 & DP2 */}
            {form.type === "pelunasan" && (
            <div className="grid grid-cols-2 gap-2 mt-4">
                <div>
                    <label>Down Payment 1</label>
                    <Select
                    className="w-full max-h-[10vh] text-sm"
                    classNames={{
                        control: () => 'border rounded-md shadow-sm hover:border-gray-400',
                        option: ({ isFocused }) =>
                        isFocused ? 'bg-blue-100 text-blue-900' : 'bg-white text-gray-800',
                    }}
                    placeholder="Pilih DP"
                    options={options}
                    value={options.find(opt => opt.value === String(form.dp1)) || null}
                    onChange={(selected) => {
                        setForm({
                        ...form,
                        dp1: selected?.value ?? '',
                        nilai_dp1: selected?.total ?? selected?.totalnote ?? 0,
                        dp1_tgl: selected?.created_at ?? selected?.input_date ?? '',
                        });
                    }}
                    isClearable
                    isSearchable
                    menuPlacement="auto"
                    menuPosition="fixed"
                    />
                </div>
                <div>
                    <label>Down Payment 2</label>
                    <Select
                        className="w-full max-h-[10vh] text-sm"
                        classNames={{
                            control: () => 'border rounded-md shadow-sm hover:border-gray-400',
                            option: ({ isFocused }) =>
                            isFocused ? 'bg-blue-100 text-blue-900' : 'bg-white text-gray-800',
                        }}
                        placeholder="Pilih DP"
                        options={options}
                        value={options.find((opt) => opt.value === form.dp2) || null}
                        onChange={(selected) => {
                            setForm({
                            ...form,
                            dp2: selected?.value ?? '',
                            nilai_dp2: selected?.total ?? selected?.totalnote ?? 0,
                            dp2_tgl: selected?.created_at ?? selected?.input_date ?? '',
                            });
                        }}
                        isClearable
                        isSearchable
                        menuPlacement="auto" 
                        menuPosition="fixed"
                        />  
                </div>
            </div>
            )}
            <button type="button"
            onClick={() => setShowPreview(true)}  className="flex items-center bg-black/100 hover:bg-black/70 text-white p-2 px-4 rounded mt-4 flex flex-row gap-2"><Eye size={16}/> Preview Ajuan</button>
        </div>

        {showPreview && (
            <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                <div className="bg-white p-6 rounded shadow-lg w-[1000px] max-h-[90vh] overflow-y-auto">
                    <h2 className="text-lg font-bold mb-4">Preview Ajuan</h2>
                    <div className='flex flex-row gap-8'>
                        <div className="w-full w-1/4 px-1">
                            <img src="/v2/images/mki.jpg" alt="Logo" />
                        </div>
                        <div className="w-full w-1/4 gap-2 px-2 flex flex-col text-xs">
                            <label>&nbsp;</label>
                            <div className="flex items-center gap-2">
                                {form.type==="um" ? <SquareCheckBig size={16} /> : <Square size={16}  />}
                                Permintaan Uang Muka
                            </div>
                            <div className="flex items-center gap-2">
                                {form.type==="reimburse" ? <SquareCheckBig size={16}  /> : <Square size={16}  />} Reimbursement
                            </div>
                            <div className="flex items-center gap-2">
                                {form.type==="dp" ? <SquareCheckBig size={16} /> : <Square size={16} />} DP ke vendor/talent
                            </div>
                            <div className="flex items-center gap-2">
                                {form.type==="pelunasan" ? <SquareCheckBig size={16} /> : <Square size={16} />} Pelunasan ke vendor/talent
                            </div>
                        </div>
                        <div className="w-full w-1/4 px-2 text-xs">
                            Transfer Bank
                            <table className="min-w-full">
                                <tr>
                                    <td className="text-left font-medium ">Nama Bank</td>
                                    <td className="text-left font-medium">:</td>
                                    <td className="text-left font-medium text-gray-700">{form.bank}</td>
                                </tr>
                                <tr>
                                    <td className="text-left font-medium ">No. rekening</td>
                                    <td className="text-left font-medium">:</td>
                                    <td className="text-left font-medium text-gray-700">{form.no_rek}</td>
                                </tr>
                                <tr>
                                    <td className="text-left font-medium ">Atas Nama</td>
                                    <td className="text-leftfont-medium">:</td>
                                    <td className="text-left font-medium text-gray-700">{form.atas_nama}</td>
                                </tr>
                                <tr>
                                    <td className="text-left font-medium ">Cabang</td>
                                    <td className="text-left font-medium">:</td>
                                    <td className="text-left font-medium text-gray-700">{form.cabang}</td>
                                </tr>
                                <tr>
                                    <td className="text-left font-medium ">Tgl Request bayar</td>
                                    <td className="text-left font-medium">:</td>
                                    <td className="text-left font-medium text-gray-700">{format(new Date(form.request_date), "dd MMM yyyy")}</td>
                                </tr>
                            </table>
                        </div>
                        <div className="w-full w-1/4 px-2 text-xs">
                            &nbsp;
                            <table className="min-w-full">
                                <tr>
                                    <td className="text-left font-medium ">Tgl Pengajuan</td>
                                    <td className="text-left font-medium text-gray-700">: {format(new Date(), "dd MMM yyyy")}</td>
                                </tr>
                                <tr>
                                    <td className="text-left font-medium ">Nama PIC</td>
                                    <td className="text-left font-medium text-gray-700">: {user.name}</td>
                                </tr>
                                <tr>
                                    <td className="text-left font-medium ">Nama Event</td>
                                    <td className="text-left text-sm font-medium text-gray-700">: {form.event}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div className='flex flex-row mt-4'>
                        <table className='min-w-full border border-black/100 mb-2 border-collapse px-2 py-2'>
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="border border-black px-2 py-2 text-center font-bold ">Keterangan</th>
                                    <th className="border border-black px-2 py-2 text-center font-bold">Nama Vendor/Talent</th>
                                    <th className="border border-black px-2 py-2 text-center font-bold">Nilai</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white">                              
                                {nominals.map((item, i) => (
                                    <tr>
                                        <td key={i} className='border border-black text-center'>{item.note}</td>
                                        <td key={i} className='border border-black text-center'>{form.vendor}</td>
                                        <td className='border border-black text-right'>Rp. {formatNumber(item.value)}</td>
                                    </tr>
                                    
                                ))}
                                <tr>
                                    <td></td>
                                    <td className='border border-black text-right font-bold p-1'>Total</td>
                                    <td className='text-right font-bold'>Rp. {formatNumber(getTotal())}</td>
                                </tr>
                                <tr>
                                    <td className="border border-black px-2 py-1 font-bold ">Sudah DP</td>
                                    <td className="border border-black px-2 py-1 font-bold"></td>
                                    <td className="border border-black px-2 py-1 font-bold text-right">  
                                    </td>
                                </tr>
                                <tr>
                                    
                                    <td className="border border-black px-2 py-1">Tgl DP 1 : {form.dp1_tgl ==="0000-00-00 00:00:00" || form.dp1_tgl ==="" ? "" : format(new Date(form.dp1_tgl), "dd MMM yyyy")}</td>
                                    <td className="border border-black px-2 py-1"></td>
                                    <td className="border border-black px-2 py-1">
                                        
                                    </td>
                                </tr>
                                <tr>
                                    
                                    <td className="border border-black px-2 py-1">Nilai DP 1 : {form.nilai_dp1==="0" ? "" : new Intl.NumberFormat('id-ID', {
                                            style: 'currency',
                                            currency: 'IDR',
                                            minimumFractionDigits: 0,
                                            }).format(form.nilai_dp1
                                        )} </td>
                                    <td className="border border-black px-2 py-1"></td>
                                    <td className="border border-black px-2 py-1">
                                        
                                    </td>
                                </tr>                
                                <tr>
                                    <td className="border border-black px-2 py-1">Tgl DP 2 : {form.dp2_tgl ==="0000-00-00 00:00:00" || form.dp2_tgl ==="" ? "" : format(new Date(form.dp2_tgl), "dd MMM yyyy")}</td>
                                    <td className="border border-black px-2 py-1"></td>
                                    <td className="border border-black px-2 py-1">
                                        
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-black px-2 py-1">Nilai DP 2 : {form.nilai_dp2==="0" ? "" : new Intl.NumberFormat('id-ID', {
                                            style: 'currency',
                                            currency: 'IDR',
                                            minimumFractionDigits: 0,
                                            }).format(form.nilai_dp2
                                        )} </td>
                                    <td className="border border-black px-2 py-1"></td>
                                    <td className="border border-black px-2 py-1">
                                        
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-black px-2 py-1">Kekurangan Uang Muka yang harus di transfer dari Perusahaan:  </td>
                                    <td className="border border-black px-2 py-1"></td>
                                    <td className="border border-black px-2 py-1">
                                        
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-black px-2 py-1">Kelebihan uang muka yang harus dikembalikan ke perusahaan:   </td>
                                    <td className="border border-black px-2 py-1"></td>
                                    <td className="border border-black px-2 py-1">
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {form.attachments.length > 0 && (
                    <div className="mt-4 grid grid-cols-2 gap-2">
                        {form.attachments.map((att, idx) => (
                        <img
                            key={idx}
                            src={att.preview}
                            alt={`Preview ${idx}`}
                            className="w-full h-auto rounded border"
                        />
                        ))}
                    </div>
                    )}

                    <div className="mt-4 flex justify-end gap-2">
                    <button
                        onClick={() => setShowPreview(false)}
                        className="bg-gray-400 text-white px-4 py-2 rounded"
                    >
                        Close
                    </button>
                    <button
                        onClick={handleSubmit}
                        className="bg-green-600 text-white px-4 py-2 rounded"
                    >
                        Submit
                    </button>
                    </div>
                </div>
            </div>
        )}
        
        <ModalAddEvent
        isOpen={openEventModal}
        onClose={() => setOpenEventModal(false)}
        onAdded={(newEvent) => setEvents([...events, newEvent])}
        />
        <ModalAddBank
        isOpen={openBankModal}
        onClose={() => setOpenBankModal(false)}
        onAdded={(newBank) => setBank([...bank, newBank])}
        />
        <ModalAddVendor
        isOpen={openVendorModal}
        onClose={() => setOpenVendorModal(false)}
        onAdded={(newVendors) => setVendors([...vendors, newVendors])}
        />
        <ModalAddPic
        isOpen={openPicModal}
        onClose={() => setOpenPicModal(false)}
        onAdded={(newPic) => setPics([...pic, newPic])}
        />
        
    </div>
  );
}
